<template>
  <div class="container">
    <template v-if="!successful_submit">
      <div class="separator"></div>
      <div class="quiz-form-wrap">
        <form
          @submit.prevent="quizSubmit"
          action="#"
          id="quiz-form"
          class="edit-form"
        >
          <div class="form-group">
            <div
              class="input-wrap"
              :class="{ 'has-error': hasError('surf_date') }"
            >
              <label for="surf_date">{{ $t("מתי תרצו לגלוש?") }}</label>
              <datepicker
                :placeholder="$t('בחר תאריך')"
                wrapper-class="date-picker-wrap"
                format="dd/MM/yyyy"
                v-model="quiz_results.surf_date"
                :language="he"
              ></datepicker>
              <span v-if="hasError('surf_date')" class="error">{{
                $t("שדה זה הוא חובה")
              }}</span>
            </div>
            <div
              class="input-wrap"
              :class="{ 'has-error': hasError('surf_level') }"
            >
              <label for="surf_level">{{
                $t("מהי רמת הגלישה של הקבוצה?")
              }}</label>
              <select
                v-model="quiz_results.surf_level"
                name="surf_level"
                id="surf_level"
              >
                <option value="-1">{{ $t("בחר ברמת גלישה") }}</option>
                <option v-for="(level, i) in surf_level" :key="i">
                  {{ level.name }}
                </option>
              </select>
              <span v-if="hasError('surf_level')" class="error">{{
                $t("שדה זה הוא חובה")
              }}</span>
            </div>
          </div>
          <div class="form-group">
            <div
              class="input-wrap"
              :class="{ 'has-error': hasError('preferred_site') }"
            >
              <label for="preferred_site">{{
                $t("האם יש אתר סקי מועדף?")
              }}</label>
              <select
                v-model="quiz_results.preferred_site"
                name="preferred_site"
                id="preferred_site"
              >
                <option value="-1">{{ $t("בחר באתר סקי") }}</option>
                <option v-for="(site, i) in preferred_site" :key="i">
                  {{ site }}
                </option>
              </select>
              <span v-if="hasError('preferred_site')" class="error">{{
                $t("שדה זה הוא חובה")
              }}</span>
            </div>
            <div
              class="input-wrap"
              :class="{ 'has-error': hasError('surf_types') }"
            >
              <label for="surf_types">{{ $t("על מה גולשים?") }}</label>
              <select
                v-model="quiz_results.surf_types"
                name="surf_types"
                id="surf_types"
              >
                <option value="-1">{{ $t("בחר במה גולשים") }}</option>
                <option v-for="(type, i) in surf_types" :key="i">
                  {{ type.name }}
                </option>
              </select>
              <span v-if="hasError('surf_types')" class="error">{{
                $t("שדה זה הוא חובה")
              }}</span>
            </div>
          </div>
          <div class="form-group">
            <div
              class="input-wrap"
              :class="{ 'has-error': hasError('max_surfers') }"
            >
              <label for="max_surfers">{{ $t("בכמה גולשים מדובר?") }}</label>
              <select
                v-model="quiz_results.max_surfers"
                name="max_surfers"
                id="max_surfers"
              >
                <option value="-1">{{ $t("כמות גולשים") }}</option>
                <option v-for="num in parseInt(max_surfers)" :key="num">
                  {{ num }}
                </option>
              </select>
              <span v-if="hasError('max_surfers')" class="error">{{
                $t("שדה זה הוא חובה")
              }}</span>
            </div>
            <div
              class="input-wrap"
              :class="{ 'has-error': hasError('surf_when_talk') }"
            >
              <label for="surf_when_talk">{{
                $t("מתי נוח שנתקשר אליך?")
              }}</label>
              <input
                type="text"
                v-model="quiz_results.surf_when_talk"
                :placeholder="$t('מתי נוח שנתקשר אליך?')"
                id="surf_when_talk"
              />
              <span v-if="hasError('surf_when_talk')" class="error">{{
                $t("שדה זה הוא חובה")
              }}</span>
            </div>
          </div>
          <div class="form-group">
            <div
              class="input-wrap full"
              :class="{ 'has-error': hasError('notes') }"
            >
              <label for="notes">{{
                $t(
                  "אנא כתבו כאן אם יש משהו נוסף שחשוב לך להעביר למומחה הסקי שלנו"
                )
              }}</label>
              <textarea
                name="notes"
                id="notes"
                v-model="quiz_results.notes"
                :placeholder="$t('הקלד טקסט כאן...')"
              ></textarea>
              <span v-if="hasError('notes')" class="error">{{
                $t("שדה זה הוא חובה")
              }}</span>
            </div>
          </div>
          <div class="form-group">
            <button type="submit" ref="submitBtn" class="dark-blue-button">
              {{ $t("שלח") }}
            </button>
          </div>
        </form>
      </div>
    </template>
    <template v-else>
      <div class="successful-submit">
        <div class="img">
          <img :src="success_image" alt="" />
        </div>
        <div class="info-success">
          <div class="title">{{ success_title }}</div>
          <div class="sub-title">{{ success_sub_title }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { api } from "../../API";
import Datepicker from "@sum.cumo/vue-datepicker";
import { he } from "@sum.cumo/vue-datepicker/dist/locale";
import "@sum.cumo/vue-datepicker/dist/vuejs-datepicker.css";
import { $t } from "../../i18n";

import Vue from "vue";

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      he: he,
      successful_submit: false,
      surf_level: window.siteData.surf_levels,
      preferred_site: window.siteData.preferred_site,
      surf_types: window.siteData.surf_types,
      max_surfers: window.siteData.max_surfers,
      // surf_important: window.siteData.surf_important,
      thanks_message: window.siteData.thanks_message,
      success_title: window.siteData.success_title,
      success_sub_title: window.siteData.success_sub_title,
      success_image: window.siteData.success_image,
      quiz_results: {
        surf_date: null,
        surf_level: -1,
        preferred_site: -1,
        surf_types: -1,
        max_surfers: -1,
        surf_when_talk: "",
        notes: "",
        leadId: $("input[type=hidden]#leadId").val(),
      },
      form_errors: [],
    };
  },
  computed: {},
  methods: {
    quizSubmit() {
      $(this.$refs.submitBtn).btnLoader().show();
      this.form_errors = [];

      api
        .submitQuiz(this.quiz_results)
        .then((res) => {
          api.REQUESTING_QUIZ_SUBMIT = false;
          $(this.$refs.submitBtn).btnLoader().hide();
          this.form_errors = [];
          this.successful_submit = true;
          $(".quiz-description").html(this.thanks_message);
        })
        .catch((err) => {
          api.REQUESTING_QUIZ_SUBMIT = false;
          $(this.$refs.submitBtn).btnLoader().hide();
          Vue.nextTick(() => {
            this.form_errors = err.responseJSON.data.form_errors;
          });
        });
    },
    hasError(key) {
      return this.form_errors.includes(key);
    },
  },
};
</script>
